<template>
  <div
    ref="coursePage"
    :class="state.recommendedCourses.length ? 'koc-view koc-course-page border-bottom' :'koc-view koc-course-page'"
  >
    <div
      v-if="state.resumeModal"
      class="resume-modal"
    >
      <div class="resume-modal-overlay" />
      <div class="resume-modal-container">
        <div class="resume-modal-container-header">
          <font-awesome-icon
            :icon="['fa', 'xmark']"
            class="close-button"
            color="var(--koc-default-text)"
            size="2x"
            @click="closeModal()"
          />
        </div>
        <div class="resume-modal-container-body">
          <div class="resume-modal-container-body-header koc-montserrat">
            you have previously watched
          </div>
          <div
            class="resume-modal-container-body-course koc-montserrat"
            v-html="state.course.title"
          />
          <div class="resume-modal-container-body-continue koc-montserrat">
            do you want to continue where you left off?
          </div>
          <div class="resume-modal-container-body-copy">
            If you choose to continue you will start at the lesson where you left off.
          </div>
          <div class="resume-modal-container-body-buttons">
            <span
              class="resume-modal-container-body-buttons-start"
              @click="play()"
            >start over</span>
            <span
              class="resume-modal-container-body-buttons-continue"
              @click="resume()"
            >continue</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="state.loaded"
      class="koc-course-page"
    >
      <div
        ref="navbar"
        class="koc-course-page-navbar"
        :style="`position: sticky; top: ${state.adjustedTop}px;`"
      >
        <div :class="state.activeSection === 'details' ? 'koc-course-page-navbar-title koc-montserrat active' : 'koc-course-page-navbar-title koc-montserrat'">
          <span @click="setActiveSection('details')">Course Details</span>
        </div>
        <div :class="state.activeSection === 'lessons' ? 'koc-course-page-navbar-title koc-montserrat active' : 'koc-course-page-navbar-title koc-montserrat'">
          <span @click="setActiveSection('lessons')">Lessons</span>
        </div>
        <div :class="state.activeSection === 'instructors' ? 'koc-course-page-navbar-title koc-montserrat active' : 'koc-course-page-navbar-title koc-montserrat'">
          <span @click="setActiveSection('instructors')">Instructors</span>
        </div>
        <div :class="state.activeSection === 'similar' ? 'koc-course-page-navbar-title koc-montserrat active' : 'koc-course-page-navbar-title koc-montserrat'">
          <span @click="setActiveSection('similar')">Similar Courses</span>
        </div>
        <div :class="state.activeSection === 'discuss' ? 'koc-course-page-navbar-title alt koc-montserrat active' : 'koc-course-page-navbar-title alt koc-montserrat'">
          <span @click="setActiveSection('discuss')">Discuss</span>
        </div>
        <div
          v-if="state.course.gear"
          :class="state.activeSection === 'gear' ? 'koc-course-page-navbar-title alt koc-montserrat active' : 'koc-course-page-navbar-title alt koc-montserrat'"
        >
          <span @click="setActiveSection('gear')">Gear Guide</span>
        </div>
        <div
          v-if="state.course.downloads"
          :class="state.activeSection === 'resources' ? 'koc-course-page-navbar-title alt koc-montserrat active' : 'koc-course-page-navbar-title alt koc-montserrat'"
        >
          <span @click="setActiveSection('resources')">Resources</span>
        </div>
      </div>
      <div class="koc-course-page-wrapper">
        <div class="koc-course-page-wrapper-container">
          <div
            ref="video"
            :class="(state.seamlessPlayer.isPlaying && state.hasUser) ? 'koc-course-page-video playing' : 'koc-course-page-video'"
          >
            <div>
              <div
                v-if="state.showCourseImage"
                class="koc-course-page-video-image"
              >
                <div
                  class="koc-course-page-video-image-thumbnail"
                  :style="`background-image: url(${state.course.images.full})`"
                />
                <font-awesome-icon
                  v-if="state.course.lessons.length > 1 && state.allowFirstLesson || state.hasAccess"
                  :icon="['fa', 'circle-play']"
                  class="play-button"
                  color="#ffffff"
                  size="5x"
                  @click="resumeOrPlay()"
                />
              </div>
              <div
                v-else-if="!state.showRecommendations"
                id="jwcourseplayer"
                class="seamless-player"
              />
              <div
                v-else
                class="koc-course-page-video-recommendations"
              >
                <div
                  v-for="course in state.similarCourses"
                  :key="course.id"
                  class="koc-course-page-video-recommendations-course"
                >
                  <a :href="FormattingService.formatUrl(course)">
                    <div class="koc-course-page-video-recommendations-course-image">
                      <div
                        class="koc-course-page-video-recommendations-course-image-thumbnail"
                        :style="`background-image: url(${course.images.full})`"
                      />
                      <div class="koc-course-page-video-recommendations-course-image-details">
                        <div
                          class="koc-course-page-video-recommendations-course-image-details-title"
                          v-html="course.title"
                        />
                        <div
                          class="koc-course-page-video-recommendations-course-image-details-instructors"
                          v-html="FormattingService.memberDashboardLinkedInstructorArray(course.instructors, true)"
                        />
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div class="koc-course-page-video-progress-bar">
                <progress-bar
                  v-if="state.hasUser"
                  :lessons="state.course.lessons"
                  :expanded-view="true"
                />
              </div>
            </div>
            <div class="koc-course-page-video-controls">
              <div
                v-if="state.hasAccess"
                class="koc-course-page-video-logged-in"
              >
                <div class="koc-course-page-video-logged-in-left">
                  <div />
                  <div class="koc-course-page-video-logged-in-left-autoplay">
                    <span class="koc-course-page-video-logged-in-left-text koc-montserrat">AUTOPLAY</span>
                    <div>
                      <label class="koc-autoplay-toggle-switch">
                        <input
                          class="koc-autoplay-toggle-switch-button"
                          :class="state.seamlessPlayer.autoplay ? 'right' : 'left'"
                          type="checkbox"
                          @click="toggleAutoplay"
                        >
                        <span
                          class="koc-autoplay-toggle-slider round"
                          :class="state.seamlessPlayer.autoplay ? 'right' : 'left'"
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div class="koc-course-page-video-logged-in-middle">
                  <div class="koc-course-page-video-logged-in-middle-link discuss">
                    <a
                      :href="state.course.discussion"
                      target="_blank"
                    >
                      discuss course
                      <font-awesome-icon
                        :icon="['fa', 'circle-info']"
                        class="video-info-icon"
                        color="var(--koc-text-default)"
                        @mouseover="state.showTooltip = true"
                        @mouseleave="state.showTooltip = false"
                      />
                    </a>
                    <div
                      v-if="state.showTooltip"
                      class="discuss-tooltip"
                    >
                      <p class="discuss-tooltip-text">
                        Have a question or comment about this course? Head over to the community to share insight, get feedback and help other members. could be kind of long. It’s usually In some cases you may even get to chat with the
                        instructor!
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="state.course.gear"
                    class="koc-course-page-video-logged-in-middle-link gear"
                  >
                    <a
                      @click="scrollToDiv('gear')"
                    >view gear guide</a>
                  </div>
                  <div
                    v-if="state.course.downloads"
                    class="koc-course-page-video-logged-in-middle-link resources"
                  >
                    <a
                      @click="scrollToDiv('resources')"
                    >get course resources</a>
                  </div>
                </div>
                <div
                  class="koc-course-page-video-logged-in-right"
                >
                  <font-awesome-icon
                    :icon="state.favoriteIcon"
                    class="info-icon"
                    :color="state.iconColor"
                    @click="toggleBookmark"
                    @mouseover="state.hoverIcon = true"
                    @mouseleave="state.hoverIcon = false"
                  />
                </div>
              </div>
              <div
                v-else
                class="koc-course-page-video-logged-out"
              >
                <div class="koc-course-page-video-logged-out-left" />
                <div
                  v-if="state.course.lessons.length > 1 && !isFreeCourse && state.allowFirstLesson"
                  class="koc-course-page-video-logged-out-right"
                  @click="resumeOrPlay()"
                >
                  <font-awesome-icon
                    :icon="['fa', 'hand-point-up']"
                    class="video-info-icon"
                    color="var(--primary-color)"
                  />
                  <span class="koc-course-page-video-logged-out-right-text koc-montserrat">
                    watch the first lesson-free-above!
                  </span>
                </div>
              </div>
              <hr>
            </div>
          </div>
          <div
            ref="details"
            class="koc-course-page-details"
          >
            <div class="koc-course-page-details-info">
              <h2
                class="koc-course-page-details-info-title koc-montserrat koc-title"
                v-html="state.course.title"
              />
              <div class="koc-course-page-details-info-instructors">
                <div class="koc-course-page-details-info-instructors-images">
                  <img
                    v-for="instructor in state.course.instructors"
                    :key="instructor.id"
                    :src="instructor.images.full"
                  >
                </div>
                <div>
                  <p v-html="FormattingService.memberDashboardLinkedInstructorArray(state.course.instructors)" />
                </div>
              </div>
              <div
                v-if="state.course.display_publish_date"
                class="koc-course-page-details-info-published"
              >
                Published {{ FormattingService.formatDate(state.course.dates.created) }}
              </div>
            </div>
            <hr>
            <div
              v-if="state.course.is_archived"
              class="koc-course-page-container-archived"
            >
              <div
                v-if="state.hasArchiveAccess"
                class="koc-course-page-container-wrapper-details-content"
                v-html="state.course.content.rendered"
              />
              <div v-else>
                <div
                  v-if="!state.hasUser"
                  class="koc-course-page-details-content"
                >
                  <div class="koc-course-page-details-content-free">
                    <span class="koc-course-page-details-content-free-cost koc-montserrat">Course Unavailable</span>
                    <a href="https://members.kelbyone.com/">
                      <button class="koc-course-button">login</button>
                    </a>
                    <div
                      class="koc-course-page-details-content-free-info"
                      v-html="`This course is not currently available for purchase or viewing. If you've previously purchased this course, please log in.`"
                    />
                  </div>
                </div>
                <div
                  v-else
                  class="koc-course-page-details-content"
                >
                  <div class="koc-course-page-details-content-free">
                    <span class="koc-course-page-details-content-free-cost koc-montserrat">Course Unavailable</span>
                    <div
                      class="koc-course-page-details-content-free-info"
                      v-html="`This course is not currently available for purchase or viewing.`"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="koc-course-page-container-not-archived"
            >
              <div
                v-if="state.hasAccess"
                class="koc-course-page-container-wrapper-details-content"
                v-html="state.course.content.rendered"
              />
              <div v-else>
                <div
                  v-if="state.is_vip_course"
                  class="koc-course-page-details-content-cost"
                >
                  <div class="koc-course-page-details-content-cost-paid single">
                    <span class="koc-course-page-details-content-free-cost koc-montserrat">Exclusive VIP Course</span>
                    <a :href="state.vipSignupLink">
                      <button class="koc-course-button">join vip</button>
                    </a>
                    <div
                      class="koc-course-page-details-content-free-info"
                      v-html="state.showDescription ? `${state.course.content.rendered} <br><br> ${state.vipBonusText}` : `${state.partialDescription}...`"
                    />
                    <a
                      class="koc-course-page-details-content-free-toggle"
                      @click="toggleDescription"
                    >{{ state.showDescription ? 'READ LESS' : 'READ MORE' }}</a>
                  </div>
                </div>
                <div
                  v-else-if="isFreeCourse"
                  class="koc-course-page-details-content-cost"
                >
                  <div class="koc-course-page-details-content-cost-paid single">
                    <span class="koc-course-page-details-content-free-cost koc-montserrat">FREE</span>
                    <a :href="state.freeSignupLink">
                      <button class="koc-course-button">join now</button>
                    </a>
                    <div
                      class="koc-course-page-details-content-free-info"
                      v-html="state.showDescription ? `${state.course.content.rendered} <br><br> ${state.freeBonusText}` : `${state.partialDescription}...`"
                    />
                    <a
                      class="koc-course-page-details-content-free-toggle"
                      @click="toggleDescription"
                    >{{ state.showDescription ? 'READ LESS' : 'READ MORE' }}</a>
                  </div>
                </div>
                <div
                  v-else
                  class="koc-course-page-details-content-cost"
                >
                  <div
                    v-if="state.hasCouresOffer"
                    :class="state.hasBothOffers ? 'koc-course-page-details-content-cost-paid' : 'koc-course-page-details-content-cost-paid single'"
                  >
                    <div class="koc-course-page-details-content-cost-paid-wrapper">
                      <span
                        v-if="state.courseOfferHasDiscount"
                        class="koc-course-page-details-content-cost-paid-wrapper-dollar original"
                      ><span class="koc-course-page-details-content-cost-paid-wrapper-dollar-strikeout">{{ state.courseOfferOriginalCost }}</span></span>
                      <span class="koc-course-page-details-content-cost-paid-wrapper-dollar membership koc-montserrat">{{
                        state.courseOfferSplitCost[0]
                      }}</span>
                      <span
                        v-if="state.courseOfferSplitCost.length > 1"
                        class="koc-course-page-details-content-cost-paid-wrapper-cents membership koc-montserrat"
                      >{{ state.courseOfferSplitCost[1] }}</span>
                      <!--<span :class="state.courseOfferSplitCost.length > 1 ? 'month' : 'month-no-cents'">/Lifetime</span>-->
                    </div>
                    <a :href="state.courseOfferLink">
                      <button class="koc-course-button">Buy course</button>
                    </a>
                    <div
                      class="koc-course-page-details-content-cost-paid-info"
                      v-html="state.showDescription ? state.course.content.rendered : `${state.partialDescription}...`"
                    />
                    <a
                      class="koc-course-page-details-content-cost-paid-wrapper-toggle koc-montserrat"
                      @click="toggleDescription"
                    >{{ state.showDescription ? 'READ LESS' : 'READ MORE' }}</a>
                  </div>
                  <div
                    v-if="state.hasMembershipOffer && state.hasCouresOffer"
                    class="koc-course-page-details-content-cost-middle"
                  >
                    OR
                  </div>
                  <div
                    v-if="state.hasMembershipOffer"
                    :class="state.hasBothOffers ? 'koc-course-page-details-content-cost-paid' : 'koc-course-page-details-content-cost-paid single'"
                  >
                    <div class="koc-course-page-details-content-cost-paid-wrapper">
                      <span
                        v-if="state.membershipOfferHasDiscount"
                        class="koc-course-page-details-content-cost-paid-wrapper-original"
                      >${{ state.membershipOfferOriginalCost }}</span>
                      <span class="koc-course-page-details-content-cost-paid-wrapper-dollar membership koc-montserrat">{{
                        state.membershipOfferSplitCost[0]
                      }}</span>
                      <span
                        v-if="state.membershipOfferSplitCost.length > 1"
                        class="koc-course-page-details-content-cost-paid-wrapper-cents membership koc-montserrat"
                      >{{ state.membershipOfferSplitCost[1] }}</span>
                      <span
                        :class="state.membershipOfferSplitCost.length > 1 ? 'month' : 'month-no-cents'"
                      >/Month</span>
                    </div>
                    <a :href="state.membershipOfferLink">
                      <button class="koc-course-button">join now</button>
                    </a>
                    <div
                      class="koc-course-page-details-content-cost-paid-info"
                      v-html="state.disclaimer"
                    />
                  </div>
                  <div
                    v-else-if="!state.hasMembershipOffer && !state.hasCouresOffer"
                    class="koc-course-page-details-content-cost"
                  >
                    <div class="koc-course-page-details-content-cost-paid single">
                      <div
                        class="koc-course-page-details-content-free-info"
                        v-html="state.showDescription ? `${state.course.content.rendered}` : `${state.partialDescription}...`"
                      />
                      <a
                        class="koc-course-page-details-content-free-toggle"
                        @click="toggleDescription"
                      >{{ state.showDescription ? 'READ LESS' : 'READ MORE' }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="koc-course-page-details-meta">
              <div class="koc-course-page-details-meta-container">
                <font-awesome-icon
                  :icon="['fa', 'circle-play']"
                  class="info-icon"
                  color="var(--koc-primary-color)"
                  size="lg"
                />
                <span class="koc-course-page-details-meta-container-text koc-montserrat">{{ state.course.lessons.length }} Lessons</span>
              </div>
              <div class="koc-course-page-details-meta-container">
                <font-awesome-icon
                  :icon="['fa', 'clock']"
                  class="info-icon"
                  color="var(--koc-primary-color)"
                  size="lg"
                />
                <span class="koc-course-page-details-meta-container-text koc-montserrat">{{ FormattingService.formatDuration(state.totalDuration) }} </span>
              </div>
              <div class="koc-course-page-details-meta-container">
                <font-awesome-icon
                  :icon="['fa', 'calendar-check']"
                  class="info-icon"
                  color="var(--koc-primary-color)"
                  size="lg"
                />
                <span class="koc-course-page-details-meta-container-text koc-montserrat">{{ state.course.metrics.views }}+ Views</span>
              </div>
            </div>
            <hr>
            <div
              v-if="!state.isMobile"
              ref="desktopInstructors"
              class="koc-course-page-instructors"
            >
              <div class="koc-course-page-instructors-container">
                <div
                  v-for="instructor in state.course.instructors"
                  :key="instructor.id"
                  class="koc-course-page-instructors-container-instructor"
                >
                  <img
                    :src="instructor.images.full"
                    width="242"
                    height="242"
                  >
                  <div
                    class="koc-course-page-instructors-container-instructor-name koc-montserrat"
                    v-html="`Meet ${instructor.name.display}`"
                  />
                  <p
                    v-if="instructor.content.rendered"
                    class="koc-course-page-instructors-container-instructor-bio"
                    v-html="`${instructor.content.rendered}`"
                  />
                  <div class="koc-course-page-instructors-container-instructor-social koc-montserrat">
                    <a
                      :href="FormattingService.formatUrl(instructor)"
                      class="koc-course-page-instructors-container-instructor-social-view-more koc-montserrat"
                    >
                      view more by {{ instructor.name.display }}
                    </a>
                    <div class="koc-course-page-instructors-container-instructor-social-links">
                      <a
                        v-if="instructor.social.facebook"
                        :href="formatLink(instructor.social.facebook, 'facebook')"
                        target="_blank"
                        class="koc-course-page-instructors-container-instructor-social-links-link"
                      >
                        <font-awesome-icon
                          :icon="['fab', 'facebook-f']"
                          class="info-icon"
                          color="var(--koc-secondary-color)"
                          size="lg"
                        />
                      </a>
                      <a
                        v-if="instructor.social.twitter"
                        :href="formatLink(instructor.social.twitter, 'twitter')"
                        target="_blank"
                        class="koc-course-page-instructors-container-instructor-social-links-link"
                      >
                        <font-awesome-icon
                          :icon="['fab', 'twitter']"
                          class="info-icon"
                          color="var(--koc-secondary-color)"
                          size="lg"
                        />
                      </a>
                      <a
                        v-if="instructor.social.instagram"
                        :href="formatLink(instructor.social.instagram, 'instagram')"
                        target="_blank"
                        class="koc-course-page-instructors-container-instructor-social-links-link"
                      >
                        <font-awesome-icon
                          :icon="['fab', 'instagram']"
                          class="info-icon"
                          color="var(--koc-secondary-color)"
                          size="lg"
                        />
                      </a>
                      <a
                        v-if="instructor.social.url"
                        :href="formatLink(instructor.social.url, '')"
                        target="_blank"
                        class="koc-course-page-instructors-container-instructor-social-links-link"
                      >
                        <font-awesome-icon
                          :icon="['fa', 'rss']"
                          class="info-icon"
                          color="var(--koc-secondary-color)"
                          size="lg"
                        />
                      </a>
                      <a
                        v-if="instructor.social.youtube"
                        :href="formatLink(instructor.social.youtube, 'youtube')"
                        target="_blank"
                        class="koc-course-page-instructors-container-instructor-social-links-link"
                      >
                        <font-awesome-icon
                          :icon="['fab', 'youtube']"
                          class="info-icon"
                          color="var(--koc-secondary-color)"
                          size="lg"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            ref="lessons"
            class="koc-course-page-lessons"
          >
            <div
              v-if="!state.hasAccess"
              class="koc-course-page-lessons-callout koc-montserrat"
            >
              Our Courses Are Broken Down Into Small Lessons For Easy Break / Stopping Points
            </div>
            <div
              v-for="(lesson, index) in state.viewableLessons"
              :key="lesson.id"
              class="koc-course-page-lessons-lesson-container"
            >
              <div class="koc-course-page-lessons-lesson-container-data">
                <div
                  class="koc-course-page-lessons-lesson-container-data-icon"
                  @click="playLesson(index, lesson)"
                >
                  <font-awesome-icon
                    v-if="!shouldPlay(index) || lesson.is_locked"
                    :icon="['fa', 'user-lock']"
                    class="info-icon"
                    color="var(--koc-primary-color)"
                    size="lg"
                  />
                  <font-awesome-icon
                    v-else-if="shouldPlay(index) && !lesson.completed"
                    :icon="['fa', 'circle-play']"
                    class="info-icon"
                    color="var(--koc-secondary-color)"
                    size="lg"
                  />
                  <font-awesome-icon
                    v-else
                    :icon="['fa', 'check']"
                    class="info-icon"
                    color="var(--koc-secondary-color)"
                    size="lg"
                  />
                </div>
                <div
                  class="koc-course-page-lessons-lesson-container-data-details"
                  @click="playLesson(index, lesson)"
                >
                  <div class="koc-course-page-lessons-lesson-container-data-details-row-one">
                    <div
                      class="koc-course-page-lessons-lesson-container-data-details-row-one-left"
                      v-html="`LESSON ${index + 1 }: ${lesson.title}`"
                    />
                    <div
                      class="koc-course-page-lessons-lesson-container-data-details-row-one-right"
                      v-html="FormattingService.formatDuration(lesson.duration)"
                    />
                  </div>
                  <div
                    class="koc-course-page-lessons-lesson-container-data-details-row-two"
                    @click="playLesson(index, lesson)"
                    v-html="lesson.content.rendered"
                  />
                </div>
              </div>
              <div
                v-if="index === state.seamlessPlayer.activeIndex && state.displayTranscript && state.hasAccess"
                class="koc-course-page-lessons-lesson-container-transcript"
              >
                <div
                  class="koc-course-page-lessons-lesson-container-transcript-heading"
                >
                  TRANSCRIPT: <span
                    class="koc-course-page-lessons-lesson-container-transcript-heading-toggle"
                    @click="toggleTranscript"
                  >{{ state.showTranscript ? 'HIDE TRANSCRIPT' : 'SHOW TRANSCRIPT' }}</span>
                </div>
                <div
                  v-if="state.showTranscript"
                  ref="captions"
                  :class="state.expandTranscript ? 'koc-course-page-lessons-lesson-container-transcript-content full' : 'koc-course-page-lessons-lesson-container-transcript-content shrink'"
                >
                  <span
                    v-for="(caption, index) in state.captions"
                    :key="index"
                    @click="seekFromCaption(caption)"
                    v-html="caption"
                  />
                </div>
                <span
                  v-if="state.showTranscript"
                  class="koc-course-page-lessons-lesson-container-transcript-content-toggle"
                  @click="toggleExpand"
                >{{ state.expandTranscript ? 'COLLAPSE TRANSCRIPT' : 'EXPAND TRANSCRIPT' }}</span>
              </div>
            </div>
            <div
              v-if="state.splitLessons"
              class="koc-course-page-lessons-lesson-container-button"
            >
              <button
                class="koc-course-button"
                @click="toggleLessons"
              >
                {{ state.showAllLessons ? 'REDUCE VISIBLE LESSONS' : 'SHOW ALL LESSONS' }}
              </button>
            </div>
          </div>
          <div
            v-if="state.isMobile"
            ref="mobileInstructors"
            class="koc-course-page-instructors"
          >
            <hr>
            <div
              ref="instructorsSection"
              class="koc-course-page-instructors-container"
            >
              <div
                v-for="instructor in state.course.instructors"
                :key="instructor.id"
                class="koc-course-page-instructors-container-instructor"
              >
                <img
                  :src="instructor.images.full"
                  height="242"
                  width="242"
                >
                <div
                  class="koc-course-page-instructors-container-instructor-name koc-montserrat"
                  v-html="`Meet ${instructor.name.display}`"
                />
                <p
                  class="koc-course-page-instructors-container-instructor-bio"
                  v-html="`Meet ${instructor.content.rendered}`"
                />
                <div class="koc-course-page-instructors-container-instructor-social koc-montserrat">
                  <a
                    :href="FormattingService.formatUrl(instructor)"
                    class="koc-course-page-instructors-container-instructor-social-view-more koc-montserrat"
                  >
                    view more by {{ instructor.name.display }}
                  </a>
                  <div class="koc-course-page-instructors-container-instructor-social-links">
                    <a
                      v-if="instructor.social.facebook"
                      :href="formatLink(instructor.social.facebook, 'facebook')"
                      target="_blank"
                      class="koc-course-page-instructors-container-instructor-social-links-link"
                    >
                      <font-awesome-icon
                        :icon="['fab', 'facebook-f']"
                        class="info-icon"
                        color="var(--koc-secondary-color)"
                        size="lg"
                      />
                    </a>
                    <a
                      v-if="instructor.social.twitter"
                      :href="formatLink(instructor.social.twitter, 'twitter')"
                      target="_blank"
                      class="koc-course-page-instructors-container-instructor-social-links-link"
                    >
                      <font-awesome-icon
                        :icon="['fab', 'twitter']"
                        class="info-icon"
                        color="var(--koc-secondary-color)"
                        size="lg"
                      />
                    </a>
                    <a
                      v-if="instructor.social.instagram"
                      :href="formatLink(instructor.social.instagram, 'instagram')"
                      target="_blank"
                      class="koc-course-page-instructors-container-instructor-social-links-link"
                    >
                      <font-awesome-icon
                        :icon="['fab', 'instagram']"
                        class="info-icon"
                        color="var(--koc-secondary-color)"
                        size="lg"
                      />
                    </a>
                    <a
                      v-if="instructor.social.url"
                      :href="formatLink(instructor.social.url, '')"
                      target="_blank"
                      class="koc-course-page-instructors-container-instructor-social-links-link"
                    >
                      <font-awesome-icon
                        :icon="['fa', 'rss']"
                        class="info-icon"
                        color="var(--koc-secondary-color)"
                        size="lg"
                      />
                    </a>
                    <a
                      v-if="instructor.social.youtube"
                      :href="formatLink(instructor.social.youtube, 'youtube')"
                      target="_blank"
                      class="koc-course-page-instructors-container-instructor-social-links-link"
                    >
                      <font-awesome-icon
                        :icon="['fab', 'youtube']"
                        class="info-icon"
                        color="var(--koc-secondary-color)"
                        size="lg"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="state.course.gear || state.course.downloads"
        class="koc-course-page-wrapper-gear-and-resources"
      >
        <div class="koc-course-page-wrapper-gear-and-resources-container">
          <div
            v-if="state.course.gear"
            ref="gear"
            class="gear"
          >
            <h2 class="gear-title koc-montserrat">
              Course Gear Guide
            </h2>
            <div
              class="gear-topics"
              v-html="state.course.gear"
            />
          </div>
          <div
            v-if="state.course.gear && state.course.downloads"
            class="divider"
          >
            <div class="divider-line" />
          </div>
          <div
            v-if="state.course.downloads"
            ref="resources"
            class="resources"
          >
            <h2 class="resources-title koc-montserrat">
              Additional Course Resources
            </h2>
            <div
              v-for="download in state.course.downloads"
              :key="download.title"
              class="resources-download"
            >
              <a :href="download.link">
                <font-awesome-icon
                  :icon="['fa', 'download']"
                  class="info-icon"
                  color="var(--koc-secondary-color)"
                  size="lg"
                />
                <span class="resources-download-text koc-montserrat">{{ download.title }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="state.recommendedCourses.length"
        ref="similar"
        class="koc-course-page-wrapper-similar-courses"
      >
        <div class="koc-course-page-wrapper-similar-courses-title koc-montserrat">
          Like This Course?  Check Out Similar
        </div>
        <course-page-svg :width="state.width" />
        <div class="koc-course-page-wrapper-similar-courses-collection">
          <default-collection
            :data="state.similarCourses"
            :user="state.member"
            :section="{}"
            :alt-background="true"
            style="padding-bottom: 64px;"
          />
        </div>
      </div>
    </div>
    <div
      v-else
      class="koc-course-page-container-loading"
    >
      <div class="koc-course-page-container-loading-navbar">
        <div class="koc-course-page-container-loading-navbar-title" />
        <div class="koc-course-page-container-loading-navbar-title" />
        <div class="koc-course-page-container-loading-navbar-title" />
        <div class="koc-course-page-container-loading-navbar-title" />
      </div>
      <div class="koc-course-page-container-loading-course">
        <div class="koc-course-page-container-loading-course-details">
          <div class="koc-course-page-container-loading-course-details-title">
            <div class="koc-course-page-container-loading-course-details-title-one" />
            <div class="koc-course-page-container-loading-course-details-title-two" />
            <div class="koc-course-page-container-loading-course-details-title-three" />
          </div>
          <div class="koc-course-page-container-loading-course-details-info">
            <div class="koc-course-page-container-loading-course-details-info-image" />
            <div class="koc-course-page-container-loading-course-details-info-text" />
          </div>
          <hr>
          <div class="koc-course-page-container-loading-course-details-description" />
          <hr>
          <div class="koc-course-page-container-loading-course-details-meta">
            <div class="koc-course-page-container-loading-course-details-meta-container">
              <div class="koc-course-page-container-loading-course-details-meta-container-icon" />
              <div class="koc-course-page-container-loading-course-details-meta-container-text" />
            </div>
            <div class="koc-course-page-container-loading-course-details-meta-container">
              <div class="koc-course-page-container-loading-course-details-meta-container-icon" />
              <div class="koc-course-page-container-loading-course-details-meta-container-text" />
            </div>
            <div class="koc-course-page-container-loading-course-details-meta-container">
              <div class="koc-course-page-container-loading-course-details-meta-container-icon" />
              <div class="koc-course-page-container-loading-course-details-meta-container-text" />
            </div>
          </div>
          <hr>
          <div class="koc-course-page-container-loading-course-details-instructor">
            <div class="koc-course-page-container-loading-course-details-instructor-image" />
            <div class="koc-course-page-container-loading-course-details-instructor-name" />
            <div class="koc-course-page-container-loading-course-details-instructor-bio" />
            <div class="koc-course-page-container-loading-course-details-instructor-more" />
            <div class="koc-course-page-container-loading-course-details-instructor-social">
              <span class="koc-course-page-container-loading-course-details-instructor-social-icon" />
              <span class="koc-course-page-container-loading-course-details-instructor-social-icon" />
              <span class="koc-course-page-container-loading-course-details-instructor-social-icon" />
              <span class="koc-course-page-container-loading-course-details-instructor-social-icon" />
              <span class="koc-course-page-container-loading-course-details-instructor-social-icon" />
            </div>
          </div>
        </div>
        <div class="koc-course-page-container-loading-course-video">
          <div class="koc-course-page-container-loading-course-video-image" />
          <div class="koc-course-page-container-loading-course-video-controls">
            <div class="koc-course-page-container-loading-course-video-controls-posted" />
            <div class="koc-course-page-container-loading-course-video-controls-autoplay" />
            <div class="koc-course-page-container-loading-course-video-controls-discuss" />
            <div class="koc-course-page-container-loading-course-video-controls-resources" />
            <div class="koc-course-page-container-loading-course-video-controls-favorite" />
          </div>
          <hr>
          <div
            v-for="n in 12"
            :key="n"
            class="koc-course-page-container-loading-course-video-lesson"
          >
            <div class="koc-course-page-container-loading-course-video-lesson-icon" />
            <div class="koc-course-page-container-loading-course-video-lesson-details">
              <div class="koc-course-page-container-loading-course-video-lesson-details-row">
                <div class="koc-course-page-container-loading-course-video-lesson-details-row-title" />
                <div class="koc-course-page-container-loading-course-video-lesson-details-row-duration" />
              </div>
              <div class="koc-course-page-container-loading-course-video-lesson-details-description" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./course-page.js"></script>
<style lang="scss" scoped src="./course-page.scss"></style>
